import { colors } from 'styles'

export const loadingButtonStyles = {
  loading: {
    color: colors.textWhite,
  },
}
